import React, { useState, useEffect } from 'react';
import { Alert, Modal, Button } from 'antd';
import Logo from '../../assets/img/logo.png';

import Player from './content/player';
import About from './content/about';
import Messages from './content/messages';

function Home() {
  const [visible, setVisible] = useState(true); // Управление видимостью Alert
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(true); // Состояние режима тех работ
  const [modalVisible, setModalVisible] = useState(false); // Состояние видимости модального окна

  // Функция для закрытия модального окна
  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <div className='HomePage'>
      {/* Alert для уведомления */}
      {visible && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 1000,
            width: '400px',
          }}
        >
          <Alert
            className='down qw-pc'
            message={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span className='fs-6 regular alert-text'>
                  <img src={Logo} width='50px' height='50px' />
                  <span className='ms-3'>Yeni <span className='text-gradient-two'>FaceTransfer</span> xidmətimizi sınayın!</span>
                </span>
                <span>
                  <Button type="primary" className='me-2' danger href="https://transfer.radioface.az" style={{ marginLeft: '8px' }}>Daxil ol</Button>
                </span>
              </div>
            }
            type="info"
            closable
            onClose={() => setVisible(false)}
          />
        </div>
      )}

      {/* Модальное окно для уведомления о тех работах */}
      <Modal
        title="DİQQƏT"
        visible={modalVisible}
        onCancel={handleModalClose}
        width={'90%'}
        footer={[
          <Button key="ok" onClick={handleModalClose}>
            ОК
          </Button>
        ]}
      >
        <div style={{ display: 'flex', alignItems: 'center'  }}>
          <img src={Logo} width='50px' height='50px' alt="Logo" />
          <span className='ms-3 text-white'>Portalımızda texniki işlər aparlığından bəzi məlumatlar əks olunmaya bilər! Tezliklə çətinlik aradan qaldırılacaq!</span>
        </div>
      </Modal>

      <Player />
      <About />
      <Messages />
    </div>
  );
}

export default Home;